// Brand tokens lifted verbatim from the seed-application.html mockup's
// :root custom properties, so every component references one source
// instead of re-typing hex values.
export const brand = {
  red: '#a30020',
  redDark: '#7d0019',
  redSoft: '#c0344f',
  ink: '#1f1517',
  muted: '#6b5e61',
  line: '#eadfe1',
  bg: '#ffffff',
  // The details-page card in the mockup uses a distinct, darker maroon for
  // its primary action and error states — kept separate from `red` above so
  // both pages stay pixel-accurate to their source rather than forcing one
  // shared accent.
  formPrimary: '#8b1414',
  formPrimaryDark: '#741010',
  formError: '#b00020',
  formBorder: '#e5e7eb',
}
